import QuillEditor from './QuillEditor';

export default QuillEditor;
